import { render, staticRenderFns } from "./LanguageOverlay.vue?vue&type=template&id=75371a7a&"
import script from "./LanguageOverlay.vue?vue&type=script&lang=js&"
export * from "./LanguageOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LanguageOverlay.vue?vue&type=style&index=0&id=75371a7a&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports